module.exports = __webpack_public_path__ + "static/channels-3-722ba5eeb60fb48cef6e3be6e13b8cc5.svg";